import { useCallback } from 'react';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api';
import { SearchQuery } from 'modules/workflows/types/segmentation';

interface IUserCountResponse {
  userCount: number;
  isLoading: boolean;
  getCount?: () => void;
}

const calculateListCountUrl = '/workflows/calculateScheduledUserListCount';

export const useCalculateScheduledJourneyListUserCount = ({
  emailListId,
  suppressionListIds,
  searchQueries,
}: {
  emailListId: number;
  suppressionListIds: number[];
  searchQueries: SearchQuery;
}): IUserCountResponse => {
  const { mutate, data, isLoading } = useRestMutation(calculateListCountUrl, ApiMethod.post);
  const getCount = useCallback(
    () =>
      mutate({
        emailListId,
        suppressionListIds,
        searchQueries,
      }),
    [emailListId, suppressionListIds, searchQueries, mutate],
  );

  return {
    userCount: data?.count || 0,
    isLoading,
    getCount,
  };
};
